import React, { Fragment, useState } from 'react';
import { 
    Button,
    UncontrolledTooltip
} from 'reactstrap';
import { faSync, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ButtonGroupTopActions(props) {
    const { 
        showRefreshBtn, 
        showAddBtn,
        refreshLoading,
        refreshCallback, 
        addCallback
    } = props;

    const generateRandomId = () => {
        const n = Math.floor((Math.random() * 100) + 1);
        return `id-${n}`;
    }

    const [refreshId] = useState(generateRandomId());
    const [addId] = useState(generateRandomId());

    return (
        <div>           
            {showRefreshBtn && (
                <Fragment>
                    <Button 
                        className="mb-2 mr-2 btn-icon btn-icon-only" 
                        color="primary" 
                        onClick={refreshCallback}
                        disabled={refreshLoading}
                        id={refreshId}
                    >
                        <FontAwesomeIcon spin={refreshLoading} icon={faSync} size="1x"/>
                    </Button>
                    <UncontrolledTooltip 
                        placement="left" 
                        target={refreshId}
                    >
                        Refresh
                    </UncontrolledTooltip>
                </Fragment>
                
            )}
            {showAddBtn && (
                <Fragment>
                    <Button 
                        className="mb-2 mr-2 btn-icon btn-icon-only" 
                        color="success" 
                        onClick={addCallback}
                        id={addId}
                    >
                        <FontAwesomeIcon icon={faUserPlus} size="1x"/>
                    </Button>
                    <UncontrolledTooltip 
                        placement="bottom" 
                        target={addId}
                    >
                        Add
                    </UncontrolledTooltip>
                </Fragment>
                
            )}
            
        </div>
    );
}
